document.addEventListener('alpine:init', () => {
  Alpine.data('ctrYourDay', () => ({
    swiper: null,
    mediaQuery: null,
    swiperRetries: 0,

    init() {
      this.mediaQuery = window.matchMedia('(max-width: 989px)');
      this.handleBreakpoint = this.handleBreakpoint.bind(this);
      this.handleBreakpoint();

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleBreakpoint);
      } else if (this.mediaQuery.addListener) {
        this.mediaQuery.addListener(this.handleBreakpoint);
      }
    },

    destroy() {
      if (!this.mediaQuery) return;

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.handleBreakpoint);
      } else if (this.mediaQuery.removeListener) {
        this.mediaQuery.removeListener(this.handleBreakpoint);
      }

      this.destroySwiper();
    },

    handleBreakpoint() {
      if (this.mediaQuery.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    },

    initSwiper() {
      if (this.swiper) return;

      if (typeof Swiper === 'undefined') {
        if (this.swiperRetries >= 40) return;
        this.swiperRetries += 1;
        window.setTimeout(() => this.initSwiper(), 50);
        return;
      }

      const swiperEl = this.$el.querySelector('[ref="swiper"]');
      const prevEl = this.$el.querySelector('[ref="prev"]');
      const nextEl = this.$el.querySelector('[ref="next"]');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        grabCursor: true,
        touchEventsTarget: 'container',
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
      });
    },

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    },
  }));
});
